import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import Footer from './components/Footer';
import Header from './components/Header';
import ScrollToTop from './components/ScrollToTop';
import { CartProvider } from './contexts/CartContext';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import Exclusivos from './pages/Exclusivos';
import Home from './pages/Home';
import NotFound from './pages/NotFound';
import OrderConfirmation from './pages/OrderConfirmation';
import OrderDetails from './pages/OrderDetails';
import ProductDetail from './pages/ProductDetail';
import QuemSomos from './pages/QuemSomos';

// Importar scripts do template original
const loadScript = (src) => {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
    });
};

function App() {
    useEffect(() => {
        // Carregar scripts do template original quando o componente montar
        const loadScripts = async () => {
            try {
                await loadScript('/assets/js/jquery.min.js');
                await loadScript('/assets/js/jquery.dropotron.min.js');
                await loadScript('/assets/js/browser.min.js');
                await loadScript('/assets/js/breakpoints.min.js');
                await loadScript('/assets/js/util.js');
                await loadScript('/assets/js/main.js');

                // Remover classe de preload após scripts carregarem
                document.body.classList.remove('is-preload');
            } catch (error) {
                // Erro ao carregar scripts - continuar normalmente
            }
        };

        loadScripts();
    }, []);

    return (
        <CartProvider>
            <ScrollToTop />
            <div id="page-wrapper">
                <Header />

                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/quem-somos" element={<QuemSomos />} />
                    <Route path="/exclusivos" element={<Exclusivos />} />
                    <Route path="/product/:id" element={<ProductDetail />} />
                    <Route path="/carrinho" element={<Cart />} />
                    <Route path="/checkout" element={<Checkout />} />
                    <Route path="/pedido/confirmacao" element={<OrderConfirmation />} />
                    <Route path="/pedido/:id" element={<OrderDetails />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>

                <Footer />
            </div>
        </CartProvider>
    );
}

export default App;
